import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bea900b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 3,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner large" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { serviceCallback, fetchData } from "@/api"
import { useUserStore } from "@/store"
import { notify } from "@/globals/notification"
import { isNotEmptyObject, refreshAccesstoken } from "@/helpers"
import { useRoute } from "vue-router"
import { ref } from "vue"
import BlankSlate from "@/components/blank-slate/BlankSlate.vue"
import TeamId from "@/components/team-id/GetTeamId.vue"
import TeamList from "@/components/teams-list/TeamsList.vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useUserStore()
const route = useRoute()

const loading = ref(false)
const loadingAsana = ref(false)

// console.log(process.env)

const getTeams = async () => {
  loading.value = true
  const data = await fetchData(`${process.env.VUE_APP_API_URL}/figma/webhooks`)

  // eslint-disable-next-line no-prototype-builtins
  if (data.hasOwnProperty("error")) {
    if (data.error != null) {
      notify(data.error, true)
      return
    }
  }

  if (store.webhooks.length != 0) {
    store.webhooks = []
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  data.webhooks.forEach((webhook: any) => {
    store.webhooks.push(webhook)
  })
  loading.value = false
}

const getDataFromCallback = async () => {
  loading.value = true
  const service = route.params.service
  const code = route.params.code
  const state = route.params.state

  if (service === "asana") {
    loadingAsana.value = true
  }

  const data = await serviceCallback(
    `${process.env.VUE_APP_API_URL}/${service}/callback?code=${code}&state=${state}`
  )

  // eslint-disable-next-line no-prototype-builtins
  if (data.hasOwnProperty("error")) {
    notify(data.error, true)
    loading.value = false
    loadingAsana.value = false
    return
  }

  if (service === "figma") {
    store.user = data.user
    store.has_asana = data.has_asana

    console.log(data)

    localStorage.setItem("user", JSON.stringify(data.user))
    localStorage.setItem("has_asana", JSON.stringify(data.has_asana))
    localStorage.setItem("access_token", data.access_token)
    localStorage.setItem("refresh_token", data.refresh_token)

    data.has_webhooks ? getTeams() : null
  }

  if (service === "asana") {
    console.log(data)
    store.has_asana = data.has_asana
    localStorage.setItem("has_asana", JSON.stringify(data.has_asana))
    notify("Asana connected", false)
    loadingAsana.value = false
    console.log(`Asana store ${store.has_asana}`)
  }

  loading.value = false
}

store.has_asana = JSON.parse(localStorage.getItem("has_asana"))

if (isNotEmptyObject(route.params)) {
  // console.log("callback catched")
  getDataFromCallback()
}

// Only here for async
const refreshToken = async () => {
  await refreshAccesstoken()
}
refreshToken()
store.setUser()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(store).has_asana && !loadingAsana.value && !loading.value)
      ? (_openBlock(), _createBlock(BlankSlate, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(store).has_asana)
      ? (_openBlock(), _createBlock(TeamId, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(store).has_asana)
      ? (_openBlock(), _createBlock(TeamList, { key: 2 }))
      : _createCommentVNode("", true),
    (loadingAsana.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})